import React from "react";
import Header from "./Header";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

function SmallHeader(props: Props) {
  return (
    <Header level={3} bold {...props}>
      {props.children}
    </Header>
  );
}

export default SmallHeader;
